import { render, staticRenderFns } from "./uploadCertificate.vue?vue&type=template&id=68bc2882&scoped=true"
import script from "./uploadCertificate.vue?vue&type=script&lang=js"
export * from "./uploadCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bc2882",
  null
  
)

export default component.exports